import React, { useState, useRef, useEffect } from "react";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";

import ChatUserItem from "../items/chat_user_item";
import ChatConversation from "../components/ChatConversation";
import Icon from "../../../common/components/Icon";

import search_icon from "../../../assets/icons/search.svg";
import off_icon from "../../../assets/icons/offIcon.svg";
import { t } from "i18next";

export function ChatsUI(
  searchQuery,
  setSearchQuery,
  chatList,
  currentUserId,
  filteredChatList,
  handleUserClick,
  selectedChat,
  isModalOpen,
  socketInstance,
  closeModal,
  isReadOnlyChat,
  pinnedChats,
  handlePinChat,
  handleDragEnd,
  setActiveTab
) {
  const [showMenu, setShowMenu] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowMenu(false);
      }
    };
    if (showMenu) document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showMenu]);

  return (
    <div className="flex flex-col h-full overflow-hidden">
      <Icon src="backicon" onClick={setActiveTab} className="block md:hidden fixed left-5 top-[23px] cursor-pointer z-[102]" />
<div className="flex bg-white rounded-2xl overflow-hidden h-[calc(100vh-180px)] shadow-sm border border-gray-100">
        {/* Left: Chat list */}
        <div className="flex flex-col w-[300px] md:w-[340px] border-r border-gray-100 flex-shrink-0">
          {/* Search bar */}
          <div className="p-4 flex-shrink-0" ref={menuRef}>
            <div className="flex items-center gap-2 bg-gray-100 rounded-xl px-3 py-2">
              <img src={search_icon} alt="search" className="w-4 h-4 opacity-40 flex-shrink-0" />
              <input
                type="text"
                placeholder={t("search")}
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="flex-1 bg-transparent text-sm placeholder-gray-400 focus:outline-none text-gray-700"
              />
            </div>
          </div>

          {/* Chat List */}
          <DragDropContext onDragEnd={handleDragEnd}>
            <Droppable droppableId="chats-list">
              {(provided) => (
                <div
                  className="flex-1 overflow-y-auto"
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                >
                  {filteredChatList.length > 0 ? (
                    filteredChatList.map((chat, index) => (
                      <Draggable
                        key={chat.room_id}
                        draggableId={String(chat.room_id)}
                        index={index}
                      >
                        {(provided, snapshot) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            style={{
                              ...provided.draggableProps.style,
                              opacity: snapshot.isDragging ? 0.8 : 1,
                            }}
                          >
                            <ChatUserItem
                              user={chat}
                              currentUserId={currentUserId}
                              onClick={() => handleUserClick(chat)}
                              isActive={selectedChat?.room_id === chat.room_id}
                              isPinned={pinnedChats.includes(chat.room_id)}
                              dragHandleProps={provided.dragHandleProps}
                            />
                          </div>
                        )}
                      </Draggable>
                    ))
                  ) : (
                    <div className="flex justify-center items-center h-full">
                      <img src={off_icon} alt="no chat" className="w-20 h-20 opacity-30" />
                    </div>
                  )}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </div>

        {/* Right: Chat content */}
        <div
          className={`flex-1 flex flex-col transition-transform duration-300 bg-white fixed top-0 left-0 w-full h-full z-50 md:relative md:translate-x-0 ${
            isModalOpen ? "translate-x-0" : "translate-x-full"
          }`}
        >
          {selectedChat ? (
            <ChatConversation
              key={selectedChat?.room_id}
              chat={selectedChat}
              currentUserId={currentUserId}
              socketInstance={socketInstance.current}
              closeModal={closeModal}
              isReadOnly={isReadOnlyChat ? isReadOnlyChat(selectedChat) : false}
            />
          ) : (
            <div className="flex flex-col justify-center items-center h-full gap-3 text-gray-400">
              <img src={off_icon} alt="no chat" className="w-20 h-20 opacity-20" />
              <p className="text-sm">{t("select_chat_placeholder")}</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
